import { GOD_IDS } from '../constants/management';

export const canImpersonate = (id: string | undefined): boolean => {
  return GOD_IDS.includes(id || '');
};
